import React, { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';
import { Button, Col, Dropdown, DropdownButton, InputGroup, Row } from 'react-bootstrap';
import '../../../../assets/scss/message-policy.scss';

function App({ onChange, data, isValid }) {
    const [inputList, setInputList] = useState([{ code: '+1', phone: '' }]);
    const contryCodes = ['+1', '+33', '+52', '+91', '+685', '+852'];

    useEffect(() => {
        onChange(inputList);
    }, [inputList]);

    useEffect(() => {
        if (data && data.phones && data.phones.length > 0) {
            let arr = data.phones.map(e => {
                const num = e.split('-');

                return {
                    code: num[0], phone: num[1]
                };
            });

            setInputList(arr);
        }
    }, [data]);

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
    };

    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        setInputList(list);
    };

    const handleAddClick = () => {
        setInputList([...inputList, { code: '+1', phone: '' }]);
    };

    return (
        <div className='Add-phone'>
            {inputList.map((x, i) => {
                return (
                    <>
                        <Row className='box'>
                            <Col className='col-7'>
                                <InputGroup className='mb-3'>
                                    <DropdownButton
                                        variant='outline-secondary'
                                        title={x.code}
                                        id='input-group-dropdown-1'
                                    >
                                        {contryCodes.map(code => <Dropdown.Item name='code' onClick={e => handleInputChange({ target: { name: 'code', value: code } }, i)}>{code}</Dropdown.Item>)}
                                    </DropdownButton>

                                    <InputMask mask={`9999999999`} maskChar=" " style={{ outline: '#959595 solid 1px', fontSize: '16px', borderRadius: '5px', paddingLeft: '15px', width: '230px' }} className='numberInput' value={x.phone} name='phone' onChange={e => handleInputChange(e, i)} />
                                    {/* <Form.Control aria-label='Text input with dropdown button' type="number" className='numberInput' value={x.phone} maxLength={10} name='phone' onChange={e => handleInputChange(e, i)} /> */}
                                </InputGroup>
                            </Col>

                            {inputList.length !== 1 && <Col className='col-4 p-0'>
                                <button
                                    style={{ marginTop: '10px' }}
                                    onClick={() => handleRemoveClick(i)}
                                >
                                    <i className='fa fa-trash' aria-hidden='true' /></button></Col>}

                            {!isValid && <Col className='col-12 mb-3' style={{ color: 'red' }}>This field is required</Col>}
                        </Row>
                        {inputList.length - 1 === i && <Row className='justify-content-end'> <Col className='col-7 mr-4'> <Button className='btn-sm' variant='success' onClick={handleAddClick}>Add Phone</Button></Col></Row>}
                    </>
                );
            })}
        </div>
    );
}

export default App;
